import { IVenueMapOverlay } from "./venueMapOverlay.interface";

export function createVenueMapGroundOverlay() {
  return class VenueMapGroundOverlay extends google.maps.GroundOverlay implements IVenueMapOverlay {
    id: number;
    level: number = 0;

    constructor(id: number, url: string, bounds: google.maps.LatLngBounds, options?: google.maps.GroundOverlayOptions) {
      super(url, bounds, options);
      this.id = id;
    }

    setLevel(level: number) {
      this.level = level;
    }

    getLevel(): number {
      return this.level;
    }
  }
}


